import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "./i18n";

const Word = ({ w, i, n, p }) => {
  const o = useTransform(p, [i / n, (i + 1) / n], [0.18, 1]);
  const red = /God's|plan|greater|Off|Grid/.test(w);
  return <motion.span style={{ opacity: o }} className={`inline-block mr-[0.25em] ${red ? "text-[#FF2A2A]" : ""}`}>{w}</motion.span>;
};

export const Manifesto = () => {
  const { t, lang } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = t("man.text").split(" ");
  return (
    <section ref={ref} data-testid="manifesto-section" className="px-5 md:px-10 py-28 md:py-44 bg-[#050505] border-t border-white/10">
      <div className="f-mono text-xs tracking-[0.3em] text-zinc-400 mb-10">{t("man.label")}</div>
      <p className="f-disp uppercase text-[10vw] md:text-[6vw] leading-[0.95] text-[#F5F5F7] max-w-[1400px]">
        {words.map((w, i) => <Word key={`${lang}-${i}`} w={w} i={i} n={words.length} p={scrollYProgress} />)}
      </p>
    </section>
  );
};
